import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 禁止浏览器自动恢复滚动位置，交给 Vue Router 控制
if (window.history && window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual'
}

// 项目 CSS 中 html/body 设了 overflow-x: hidden + height: 100%，
// 导致实际滚动容器是 document.body 而非 window，scrollTo 对 window 不生效。
// 统一对三个容器都复位，确保兼容。
function scrollToTop() {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

let kejianrouter = new Router({

  mode:'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页',
      titleEn: 'Home',
      keepAlive: true
    },
    component: () => import('@/views/aboutUs.vue'),
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      titleEn: 'Home',
      keepAlive: true
    },
    component: () => import('@/views/Home/Home.vue'),
  },
  {
    path: '/IndustrialAgent',
    name: 'IndustrialAgent',
    meta: { 
      title: "产业集群智能体" ,
      titleEn: 'Industrial Agent',
      keepAlive: true
    },
    component: () => import('@/views/IndustrialAgent.vue')
  },
  {
    path: '/newsdetails',
    name: 'newsdetails',
    meta: { title: "新闻详情" },
    component: () => import('@/views/NewsDetails.vue')
  },
  {
    path: '/news/detail/:id',
    name: 'newsDetail',
    meta: { title: "新闻详情" },
    component: () => import('@/views/News/NewsDetail.vue')
  },
  {
    meta: { title: "工业元宇宙" },
    path: '/metaverse',
    name: 'metaverse',
    component: () => import('@/views/metaverse.vue'),
  },
  {
    meta: { title: "工业元宇宙" },
    path: '/metaverseMobile',
    name: 'metaverseMobile',
    component: () => import('@/views/metaverseMobile.vue'),
  },
  {
    meta: { title: "图片预览" },
    path: '/imgPreview',
    name: 'imgPreview',
    component: () => import('@/views/Home/imgPreview.vue')
  },
  {
    path: '/digitalEmpowerment',
    name: 'digitalEmpowerment',
    meta: { title: 'AI赋能', titleEn: 'AI Empowerment', keepAlive: true },
    component: () => import('@/views/digitalEmpowerment.vue')
  },
  {
    path: '/integratedSolution',
    name: 'integratedSolution',
    meta: { title: '综合解决方案', titleEn: 'Comprehensive Solutions', keepAlive: true },
    component: () => import('@/views/integratedSolution.vue')
  },
  {
    path: '/tianlongbabu',
    name: 'tianlongbabu',
    meta: { title: 'AI天龙八部', titleEn: 'AI Tianlongbabu', keepAlive: true },
    component: () => import('@/views/tianlongbabu.vue')
  },
  {
    path: '/liumaishenjian',
    name: 'liumaishenjian',
    meta: { title: 'AI六脉神剑', titleEn: 'AI Six Divine Swords', keepAlive: true },
    component: () => import('@/views/liumaishenjian.vue')
  },
  {
    path: '/corporate',
    name: 'corporate',
    meta: { title: '规章制度', titleEn: 'Corporate Value', keepAlive: true },
    component: () => import('@/views/corporate.vue')
  },
  {
    path: '/qualification',
    name: 'qualification',
    meta: { title: '资质荣誉', titleEn: 'Qualification and Honor', keepAlive: true },
    component: () => import('@/views/qualification.vue')
  },
  {
    path: '/innovativeProduct',
    name: 'innovativeProduct',
    meta: { title: '产业文创', titleEn: 'Industrial Cultural Creativity', keepAlive: true },
    component: () => import('@/views/innovativeProduct.vue')
  },
  {
    path: '/hire',
    name: 'hire',
    meta: { title: '寻找超人', titleEn: 'Looking for Superman', keepAlive: true },
    component: () => import('@/views/hire.vue')
  },
  {
    path: '/us',
    name: 'us',
    meta: { title: "联系我们" },

    component: () => import('@/views/us/us.vue'),
    redirect: "/us/list",
    children: [{
      path: '/us/list',
      name: 'list',
      meta: { title: "联系我们" },
      component: () => import('@/views/us/list.vue')
    },
    {
      path: '/us/details',
      name: 'details',
      meta: { title: "人才招聘" },
      component: () => import('@/views/us/details.vue')
    },
    ]
  },
  {
    path: '/contractSpecification/:id',
    name: 'contractSpecification',
    meta: { title: '合同详情' },
    component: () => import('../views/Contract/specification.vue'),
  },
  ]
})

// // 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 切换页面时立即重置滚动位置
  scrollToTop()

  if(to.meta.title){
    //判断是否有标题
    document.title = to.meta.title + ' - AI快车科技_广东快车科技股份有限公司'
    if(to.meta.title == '首页') {
      document.title = 'AI快车科技 - 广东快车科技股份有限公司 | 数字赋能 · 产业智能体'
    }
  }

  next()
})

// 导航完成后再次确保滚动到顶部（等 DOM 渲染完毕）
kejianrouter.afterEach(() => {
  scrollToTop()
})

export default kejianrouter